<template>
	<div class="wutuList margin-t60">
		<div class="comTitle">
		    <p>职称评聘</p>
		    <span>PROFESSIONAL TITLE EVALUATION</span>
		    <em></em>
		</div>
		<ul class="wutuUL w69">
			<li v-for="(item,index) in zcppList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
        <router-link  :to="item.Url" :href="item.Url" class="flexDiv">
          <p>{{item.ShowTime2}}<i>{{setTimeformat(item.ShowTime6,'YYYY-mm')}}</i></p>
          <span>{{item.Title}}</span>
        </router-link>
			</li>
		</ul>
    <a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s">
    	<router-link :to="moreLink"><i>查看更多+</i></router-link>
    </a>
	</div>
</template>

<script>
	export default{
		name:'zcpp',
		props:{
			zcppList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/zcpp.vue